import { useState } from "react";
import AdminAPIPage from "../../api/adminAPIs";
import useDisplaySnackbar from "../../utils/useDisplaySnackbar";
 import {
   Button,
   Dialog,
   DialogActions,
   DialogContent,
   DialogTitle,
 } from "@mui/material";

interface RegenerateAnalysisProps {
  meetingId: string;
}

const RegenerateAnalysis: React.FC<RegenerateAnalysisProps> = ({ meetingId }) => {
  const { showSnackbar } = useDisplaySnackbar();
  const [showSpinner, setShowSpinner] = useState<boolean>(false);
  const [openDialog, setOpenDialog]=useState<boolean>(true);
  const enabled = !!meetingId;
  const { mutate: mutateMeetingReanalysis } = AdminAPIPage.usePostMeetingReanalysis(meetingId || "", {
    onMutate: () => {
      setShowSpinner(true);
    },
    onSuccess: () => {
      showSnackbar("success", "Reanalysis initiated successfully");
    },
    onError: (error: any) => {
      showSnackbar("error", error);
    },
    onSettled: () => {
      setShowSpinner(false);
    },
  });

   const handleOpenDialog=()=>setOpenDialog(true);
   const handleCloseDialog=()=>setOpenDialog(false);
   const handleConfirm=()=>{
     setOpenDialog(false);
     mutateMeetingReanalysis({ meeting_id: meetingId, regenerate: "True" });
   };
    return(
     <div>
      <Button
         onClick={handleOpenDialog}
         disabled={showSpinner|| !enabled}>
         {showSpinner && <p>Loading...</p>}
      </Button>
    <Dialog open={openDialog} onClose={handleCloseDialog}>
       <DialogTitle>Re-run Confirmation</DialogTitle>
       <DialogContent>Do you confirm to Regenerate the Analysis?</DialogContent>
       <DialogActions>
         <Button onClick={handleConfirm}
         variant="contained"
         size="small"
         sx={{textTransform:"none", color: "white",bgcolor: "#32376e","&:hover":{bgcolor:"#32376e"}}}>
          Yes
         </Button>
         <Button onClick={handleCloseDialog} variant="outlined" size="small"
         sx={{textTransform:"none",color:"gray"}}>
           No
         </Button>
       </DialogActions>
     </Dialog>
   </div>
   )

};

export default RegenerateAnalysis;